// -----------------------------------------------------------------------------
// MQTT CONFIG
// -----------------------------------------------------------------------------
export const BROKER_URL = import.meta.env.VITE_BROKER_URL
export const MQTT_BASE_TOPIC = 'xapp-agent'

export const MQTT_USERNAME = import.meta.env.VITE_MQTT_USERNAME
export const MQTT_PASSWORD = import.meta.env.VITE_MQTT_PASSWORD

export const MQTT_OPTIONS = [
  { header: 'RFID' },
  {
    name: 'Tap to Start',
    payload: {
      minor: false,
      result: 'Authorized',
      seapass_id: '04 6F CB DA FB 6C 81',
      tax_rate: 0,
    },
    topic: `${MQTT_BASE_TOPIC}/photobooth/app/cmd/start`,
  },
]

console.log(`BROKER_URL => ${BROKER_URL}`)
console.log(`MQTT_BASE_TOPIC => ${MQTT_BASE_TOPIC}`)
